/**
 * @generated SignedSource<<602e51446d5868f2809abfabf42556a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type UserAuthorizationLevel = "ADMIN" | "VISITOR" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type EventScreenAttendCard_query$data = {
  readonly viewer: {
    readonly authorizationLevel: UserAuthorizationLevel;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"EventAttendButtonNew_query">;
  readonly " $fragmentType": "EventScreenAttendCard_query";
};
export type EventScreenAttendCard_query$key = {
  readonly " $data"?: EventScreenAttendCard_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventScreenAttendCard_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventScreenAttendCard_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventAttendButtonNew_query"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "authorizationLevel",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "c8d03fa4d5c88b3523ec41158a122f6b";

export default node;
